// "New Location": asks for a reference, creates an inactive location and opens it.
// Used by the sidebar button (App.vue) and the dashboard tile (pages/home.vue).
export default {
  methods: {
    openNewLocationPrompt() {
      this.$prompt('Location reference (leave blank for a random one)', 'New location', {
        confirmButtonText: 'Create',
        cancelButtonText: 'Cancel',
      }).then(({value}) => {
        return this.axios.post(process.env.VUE_APP_ROOT_API + '/api/locations/',
          {
            locationReference: value,
            status: 'inactive'
          },
          {
            headers: {
              Authorization: localStorage.getItem('Authorization')
            }
          });
      }).then((response) => {
        this.$notify({
          title: 'Success',
          message: 'Location Created.',
          type: 'success'
        });

        // The location screen only reads the reference when it loads, hence the reload.
        this.$router.push('/locations/' + response.data.createdLocation.locationReference);
        this.$router.go();
      }).catch(() => {
      });
    },
  }
}



// WEBPACK FOOTER //
// ./src/mixins/newLocation.js